import { render, staticRenderFns } from "./Recoleccion.vue?vue&type=template&id=323a8308"
import script from "./Recoleccion.vue?vue&type=script&lang=js"
export * from "./Recoleccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports